<template>
    <div>
        <title>{{ $t("statistics.text_1") }} - DOFFERO®</title>
        <link
            href="https://cdn.jsdelivr.net/npm/bootstrap@5.0.2/dist/css/bootstrap.min.css"
            rel="stylesheet"
            integrity="sha384-EVSTQN3/azprG1Anm3QDgpJLIm9Nao0Yz1ztcQTwFspd3yD65VohhpuuCOmLASjC"
            crossorigin="anonymous"
        />
        <div class="cont">
            <h1 class="title">{{ $t("statistics.text_1") }}</h1>
            <h3 class="under_text">
                {{ $t("statistics.text_2") }}
            </h3>
            <div class="one_section mt-4">
                <h4 class="title">{{ $t("statistics.text_3") }}</h4>
                <div class="dash_boxes">
                    <div class="dash_box blue">
                        <div>
                            <h3>
                                {{ formatPrice(statistic.price_by_month[5]) }} €
                            </h3>
                            <p>{{ $t("statistics.text_4") }}</p>
                        </div>
                    </div>
                    <div class="dash_box orange">
                        <div>
                            <h3>{{ formatPrice(statistic.all_price) }} €</h3>
                            <p>{{ $t("statistics.text_5") }}</p>
                        </div>
                    </div>
                    <div class="dash_box green">
                        <div>
                            <h3>{{ formatPrice(statistic.avg_price) }} €</h3>
                            <p>{{ $t("statistics.text_17") }}</p>
                        </div>
                    </div>
                    <div class="dash_box yellow">
                        <div>
                            <h3>{{ formatNumber(statistic.klients_count) }}</h3>
                            <p>{{ $t("statistics.text_6") }}</p>
                        </div>
                    </div>
                </div>
                <div class="graphs">
                    <div class="graph1">
                        <div class="graph-switcher">
                            <h2 class="flex items-center relative">
                                {{ $t("dashboard.text_16") }}
                                <span v-show="activeGraph === 'types'" class="info">
                                    <span class="info_icon tooltip_hover" aria-label="info">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                            <circle cx="12" cy="12" r="10"></circle>
                                            <line x1="12" y1="16" x2="12" y2="12"></line>
                                            <line x1="12" y1="8" x2="12.01" y2="8"></line>
                                        </svg>
                                    </span>
                                    <span class="my_tooltip">{{ $t('statistics.text_20') }}</span>
                                </span>
                            </h2>
                            <div class="switcher-tabs">
                                <button
                                    type="button"
                                    class="tab-btn"
                                    :class="{ active: activeGraph === 'value' }"
                                    @click="activeGraph = 'value'"
                                >
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                        <polyline points="3 17 9 11 13 15 21 7"></polyline>
                                        <polyline points="21 16 21 7 12 7"></polyline>
                                    </svg>
                                    <span>{{ $t('statistics.text_18') }}</span>
                                </button>
                                <button
                                    type="button"
                                    class="tab-btn"
                                    :class="{ active: activeGraph === 'types' }"
                                    @click="activeGraph = 'types'"
                                >
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                        <line x1="3" y1="21" x2="21" y2="21"></line>
                                        <rect x="4" y="12" width="3" height="7"></rect>
                                        <rect x="9" y="9" width="3" height="10"></rect>
                                        <rect x="14" y="6" width="3" height="13"></rect>
                                        <rect x="19" y="3" width="3" height="16"></rect>
                                    </svg>
                                    <span>{{ $t('statistics.text_19') }}</span>
                                </button>
                            </div>
                        </div>
                        <offers-value-graph v-if="activeGraph === 'value'" :data="statistic.price_by_month" />
                        <offers-value-types-graph v-else :data="statistic.price_by_type" />
                    </div>
                    <div class="graph2">
                        <offers-count-graph :data="statistic.count_by_month" />
                    </div>
                </div>
                <div class="graphs">
                    <div
                        v-if="statistic.offers_states != null"
                        class="graph1 mb-5 mt-0"
                    >
                        <h2 class="mb-2">{{ $t("dashboard.text_31") }}</h2>
                        <graph-stavy-ponuk :data="statistic.offers_states" />
                    </div>
                    <div class="relative graph2 mb-5 mt-0">
                        <h2>{{ $t("dashboard.text_27") }}</h2>
                        <div
                            v-if="statistic.zdroj_kontaktu != null"
                            :class="{ blur: !is_paid }"
                        >
                            <graph-zdroj-kontaktu
                                :data="
                                    is_paid
                                        ? statistic.zdroj_kontaktu
                                        : {
                                              counts: [1, 1, 0, 0, 0, 0],
                                              labels: [
                                                  'Google',
                                                  'Facebook',
                                                  'Instagram',
                                                  'Newsletter',
                                                  'Osobné odporúčanie',
                                                  'Iné',
                                              ],
                                          }
                                "
                            />
                        </div>
                        <offer-alert-tomany
                            v-if="!is_paid"
                            style="top: 200px"
                        />
                    </div>
                </div>
            </div>
            <div v-if="amiowner" class="one_section relative">
                <h4 class="title">{{ $t("statistics.text_9") }}</h4>
                <p class="under_tilte_text">{{ $t("statistics.text_10") }}</p>
                <div
                    :class="{
                        blur: !can_see_subusers,
                    }"
                >
                    <sub-user-statistics
                        v-if="subuser_monthly_statistic.length > 0"
                        :subuser_statistic="subuser_statistic"
                        :subuser_monthly_statistic="subuser_monthly_statistic"
                        :subuser_monthly_statistic_price="
                            subuser_monthly_statistic_price
                        "
                    />
                    <div v-else class="without_subusers_box relative mb-20">
                        <div v-if="can_see_subusers">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="20"
                                height="20"
                                viewBox="0 0 20 20"
                                fill="none"
                            >
                                <path
                                    fill-rule="evenodd"
                                    clip-rule="evenodd"
                                    d="M18 10C18 14.4183 14.4183 18 10 18C5.58172 18 2 14.4183 2 10C2 5.58172 5.58172 2 10 2C14.4183 2 18 5.58172 18 10ZM11 6C11 6.55228 10.5523 7 10 7C9.44772 7 9 6.55228 9 6C9 5.44772 9.44772 5 10 5C10.5523 5 11 5.44772 11 6ZM9 9C8.44772 9 8 9.44772 8 10C8 10.5523 8.44772 11 9 11V14C9 14.5523 9.44772 15 10 15H11C11.5523 15 12 14.5523 12 14C12 13.4477 11.5523 13 11 13V10C11 9.44772 10.5523 9 10 9H9Z"
                                    fill="#00A3FF"
                                />
                            </svg>
                            <span>
                                {{ $t("statistics.text_11") }}
                                <a href="/admin/pouzivatelia">{{
                                    $t("statistics.text_12")
                                }}</a>
                            </span>
                        </div>
                        <offer-alert-tomany v-else style="left: 0px; top: 0px;" />
                    </div>
                </div>
                <offer-alert-tomany v-if="!can_see_subusers && subuser_monthly_statistic.length > 0" style="top: 200px" />
            </div>
        </div>
    </div>
</template>

<script>
import OffersValueGraph from "../dashboard/OffersValueGraph.vue";
import OffersCountGraph from "../dashboard/OffersCountGraph.vue";
import OffersValueTypesGraph from "../dashboard/OffersValueTypesGraph.vue";
import SubUserStatistics from "./components/SubUserStatistics.vue";
import GraphZdrojKontaktu from "./components/GraphZdrojKontaktu.vue";
import GraphStavyPonuk from "./components/GraphStavyPonuk.vue";
import OfferAlertTomany from "../offer/OfferTable_components/OffersAlertTomany.vue";
export default {
    components: {
        OffersValueGraph,
        OffersCountGraph,
        OffersValueTypesGraph,
        SubUserStatistics,
        GraphZdrojKontaktu,
        GraphStavyPonuk,
        OfferAlertTomany,
    },
    data() {
        return {
            activeGraph: 'types',
        };
    },
    props: [
        "amiowner",
        "statistic",
        "subuser_statistic",
        "subuser_monthly_statistic",
        "subuser_monthly_statistic_price",
        "is_paid",
        'paid_type',
        "amiadmin"
    ],
    methods: {
        formatPrice(value) {
            let val = (value / 1).toFixed(2).replace(".", ",");
            return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
        },
        formatNumber(value) {
            return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
        },
    },
    computed: {
        can_see_subusers() {
            // user must have small or big plan
            return this.is_paid == 1 && this.subuser_monthly_statistic.length > 0 && (this.paid_type == 'small_team' || this.paid_type == 'large_team');
        },
    },
    mounted() {
        $( ".tooltip_hover" ).hover(
            function() {
                $( this ).parent().find('.my_tooltip').css('opacity', '1');
            },
            function() {
                $( this ).parent().find('.my_tooltip').css('opacity', '0');
            },
        );
    },
};
</script>

<style lang="scss" scoped>
.without_subusers_box {
    width: 780px;
    border-radius: 6px;
    background: var(--blue-50, #eff6ff);
    display: flex;
    align-items: center;
    svg {
        margin-right: 12px;
    }
    span {
        color: var(--blue-800, #1e40af);
        font-family: Roboto;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 1px; /* 142.857% */
        a {
            color: var(--blue-800, #1e40af);
            text-decoration: underline;
        }
    }
}
.graphs {
    width: 100%;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    margin-top: 30px;
    @media (max-width: 800px) {
        flex-direction: column;
    }
    .graph1,
    .graph2 {
        width: 48%;
        @media (max-width: 800px) {
            width: 98%;
        }
        position: relative;
        .blur {
            filter: blur(10px);
            pointer-events: none;
        }
    }
    .graph1 h2{
        margin-bottom: 0;
    }
    .graph2{
        margin-top: 25px;
    }
    h2 {
        font-style: normal;
        font-weight: 600;
        font-size: 18px;
        line-height: 22px;
        color: #212541;
        .info{
            position: relative;
            height: 20px;
            margin-left: 6px;
            .info_icon{
                pointer-events: all;
                cursor: pointer;
                display: inline-flex;
                align-items: center;
                justify-content: center;
                width: 20px;
                height: 20px;
                color: #6b7280;
            }
            .my_tooltip{
                font-family: 'Roboto';
                font-style: normal;
                font-weight: 700;
                pointer-events: none;
                opacity: 0;
                display: flex;
                align-items: center;
                justify-content: center;
                width: max-content;
                max-width: 320px;
                background: #F3385A;
                box-shadow: 0px 2px 2px rgba(143, 153, 179, 0.2);
                border-radius: 6px;
                font-weight: 800;
                font-size: 12px;
                line-height: 16px;
                color: #fff;
                padding: 8px 10px;
                position: absolute;
                bottom: 22px;
                right: -7px;
                z-index: 10000;
                transition: opacity .2s ease-in-out;
                &::after{
                    content: '';
                    width: 12px;
                    height: 12px;
                    background: #F3385A;
                    position: absolute;
                    right: 10px;
                    bottom: -3px;
                    transform: rotate(45deg);
                    border-radius: 3px;
                }
            }
        }
    }
}
.graph-switcher {
    display: flex;
    justify-content: space-between;
    align-items: end;
    margin-bottom: 10px;
    .switcher-tabs {
        display: inline-flex;
        background: #ffffff;
        border: 1px solid #e5e7eb;
        border-radius: 8px;
        padding: 4px;
        gap: 4px;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);
        
        .tab-btn {
            display: flex;
            align-items: center;
            gap: 6px;
            padding: 10px 16px;
            border: none;
            background: transparent;
            border-radius: 6px;
            font-family: 'Roboto', sans-serif;
            font-size: 13px;
            font-weight: 500;
            color: #6b7280;
            cursor: pointer;
            transition: all 0.2s ease;
            white-space: nowrap;
            
            svg {
                width: 16px;
                height: 16px;
                stroke-width: 2;
            }
            
            &:hover {
                color: #374151;
                background: #f9fafb;
            }
            
            &.active {
                background: #212541;
                color: #ffffff;
                box-shadow: 0 2px 4px rgba(33, 37, 65, 0.3);
                
                svg {
                    color: #ffffff;
                }
            }
        }
    }
    
    @media (max-width: 800px) {
        position: relative;
        top: 0;
        right: 0;
        margin-bottom: 16px;
        display: flex;
        justify-content: center;
        
        .switcher-tabs {
            width: 100%;
            
            .tab-btn {
                flex: 1;
                justify-content: center;
            }
        }
    }
}
.dash_boxes {
    display: flex;
}
.dash_box {
    width: 275px;
    height: 87px;
    border-radius: 6px;
    display: flex;
    align-items: center;
    padding: 21px 17px;
    margin-right: 19px;
    &.blue {
        background: #212541;
    }
    &.orange {
        background: #f93c34;
        p {
            opacity: 0.8;
        }
    }
    &.yellow {
        background: #fbbf24;
        p {
            opacity: 0.8;
        }
    }
    &.green {
        background: #06d6a0;
        p {
            opacity: 0.8;
        }
    }
    div {
        h3 {
            color: var(--White, #fff);
            font-family: Montserrat;
            font-size: 20px;
            font-style: normal;
            font-weight: 600;
            line-height: 110%; /* 22px */
        }
        p {
            color: var(--White, #fff);
            font-family: Montserrat;
            font-size: 10px;
            font-style: normal;
            font-weight: 600;
            line-height: normal;
            letter-spacing: 1px;
            text-transform: uppercase;
            opacity: 0.6;
            margin: 0;
        }
    }
}
.cont {
    width: 95%;
    margin: 0 auto;
    padding: 35px 0;
    h1.title {
        @media only screen and (max-width: 600px) {
            width: 90%;
            margin: 0 auto;
        }
        font-family: "Roboto";
        font-style: normal;
        font-weight: 700;
        font-size: 24px;
        line-height: 28px;
        text-align: center;
        color: #000000;
    }
    h3.under_text {
        width: 700px;
        @media only screen and (max-width: 600px) {
            width: 90%;
        }
        margin: 10px auto 27px auto;
        font-family: "Roboto";
        font-style: normal;
        font-weight: 500;
        font-size: 18px;
        line-height: 150%;
        text-align: center;
        color: #9598a7;
    }
    .one_section {
        h4.title {
            color: #000;
            font-family: Roboto;
            font-size: 16px;
            font-style: normal;
            font-weight: 400;
            line-height: normal;
        }
        p.under_tilte_text {
            color: #9598a7;
            font-family: Roboto;
            font-size: 14px;
            font-style: normal;
            font-weight: 400;
            line-height: 150%; /* 21px */
        }
    }
}
</style>
